module.exports = __webpack_public_path__ + "static/media/medex logo.6c2af709.png";